module.exports = __webpack_public_path__ + "b674a9444d69eee90222259981a1e0bb.svg";